/**
 * The nav badge counts — `apps/api/src/readmodels/badges.ts`, session 17 (B).
 *
 * `.docs/17-studio-read-models.md` §B: "Nav badges: `readmodels/badges.ts` → studio
 * `{ tasks: overdue count, money: unmatched count }`, client `{ requests: open
 * decisions }`." Two shapes, one per portal's shell.
 */
import { z } from 'zod';
export const StudioBadgesSchema = z
    .object({
    tasks: z.int().describe('Overdue tasks, studio-wide — the same count the task board shows.'),
    money: z.int().describe('Unmatched Wise credits waiting in the review queue.'),
})
    .describe('The studio shell’s two nav badges.');
export const ClientBadgesSchema = z
    .object({
    requests: z
        .int()
        .describe('Open decisions waiting on this client — quotes, extras, package changes and ' +
        'content-plan sign-offs, added together.'),
})
    .describe('The client shell’s one nav badge.');
//# sourceMappingURL=badges.js.map